import Input from "./Input";

export default ({ onChange, hasError }) => {
	const handleOnChange = (val) => {
		onChange(val);
	};
	return <Input type="email" onChange={handleOnChange} hasError={hasError}  />;
};
